import React from 'react';
import LibDayPicker from 'react-day-picker';
import moment from 'moment';
import BigCalendar from 'react-big-calendar';
import PropTypes from 'prop-types';

import * as dates from '../../translate/dates';

export class DayPickerRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selecting: 0,
      startDate: props.wantedSelection.from,
      endDate: props.wantedSelection.to,
    }
  }

  componentWillReceiveProps(nextProps) {
    const p0ws = this.props.wantedSelection;
    const p1ws = nextProps.wantedSelection;
    if((
        !this.state.startDate || !this.state.endDate || isNaN(this.state.startDate.getTime()) || isNaN(this.state.startDate.getTime())
      ) && (
        p0ws.from !== p1ws.from || p0ws.to !== p1ws.to
      )) {
      this.setState({
        startDate: p1ws.from,
        endDate: p1ws.to,
      })
    }
  }

  handleDayMouseEnter = (day) => {
    if(this.state.selecting === 1) {
      this.setState({
        endDate: day
      });
      return;
    }
  }

  handleDayClick = (day) => {
    if(this.state.selecting === 0) {
      this.setState({selecting: 1, startDate: day, endDate: undefined});
      return;
    }
    if(this.state.selecting === 1) {
      this.setState({selecting: 0, endDate: day}, () => {
        const sd = this.state.startDate;
        const ed = this.state.endDate;
        this.props.onChange && this.props.onChange({
          from: sd < ed ? sd : ed, 
          to: sd < ed ? ed : sd,
        });
      });
      return;
    }
  }

  render() {
    const {realSelection} = this.props;
    const wantedSelection = {
      from: this.state.startDate,
      to: this.state.endDate,
    }
    return <DayPicker 
      enableOutsideDays
      numberOfMonths={2}
      modifiers={{
        realSelection,
        wantedSelection,
      }}
      onDayClick={this.handleDayClick}
      onDayMouseEnter={this.handleDayMouseEnter}
    />;
  }
}

export class DayPicker extends React.Component {

  getDisablingModifier() {
    if(this.props.disableBefore) {
      return {before: moment(this.props.disableBefore).toDate()}
    }
  }

  handleDayClick = (day) => {
    if(this.props.disableBefore) {
      if(moment(day).isBefore(moment(this.props.disableBefore))) {
        //this.props.onDayClick && this.props.onDayClick(moment(this.props.disableBefore).hours(0).minutes(0).toDate());
        return
      }
    }
    this.props.onDayClick && this.props.onDayClick(moment(day).startOf('day').toDate());
  }

  render() {
    return (
      <LibDayPicker 
        firstDayOfWeek={1}
        disabledDays={this.getDisablingModifier()}
        months={dates.MONTH_NAMES_LONG}
        weekdaysLong={dates.DAY_NAMES_LONG}
        weekdaysShort={dates.DAY_NAMES_SHORT}
        {...this.props} 
        onDayClick={this.handleDayClick}
      />
    )
  }
}





class ChooseYear extends React.Component {
  render() {
    let startYear = moment().subtract({years: 100}).years();
    startYear = startYear - startYear % 10;
    let years = [];
    for(let i = 19; i >= 0; i--) {
      let innerYears = [];
      for(let j = 0; j < 5; j++) {
        innerYears.push(startYear + i*5 + j)
      }
      years.push(innerYears)
    }
    return (
      <div className={"DayPickerYMD-years-container" + (this.props.active ? ' visible' : ' invisible')}>
        <table className="DayPickerYMD-years-table">
          <tbody>
            {years.map(innerYears =>
              <tr className="table-row">
                {innerYears.map(year => 
                  <td className="table-cell" onClick={(event) => {event.stopPropagation(); this.props.onChange(year)}}>{year}</td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  }
}

class ChooseMonth extends React.Component {
  render() {
    const allMonths = moment.months();
    let months = [];
    for(let i = 0; i < 4; i++) {
      let innerMonths = [];
      for(let j = 0; j < 3; j++) {
        innerMonths.push({index: i*3 + j, label: allMonths[i*3 + j]});
      }
      months.push(innerMonths)
    }
    return (
      <div className={"DayPickerYMD-years-container" + (this.props.active ? ' visible' : ' invisible')}>
        <table className="DayPickerYMD-years-table">
          <tbody>
            {months.map(innerMonths =>
              <tr className="table-row">
                {innerMonths.map(month => 
                  <td className="table-cell" 
                    onClick={(event) => {event.stopPropagation(); this.props.onChange(month.index)}}>{month.label}</td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  }
}

class ChooseDay extends React.Component {
  render() {
    return (
      <div className={this.props.active ? 'visible' : 'invisible'}>
        <DayPicker {...this.props} onDayClick={this.props.onChange} />
      </div>
    )
  }
}

export class DayPickerYMD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choosing: 0,
    };
  }

  yearChoosen = (year) => {
    this.setState({
      year,
      choosing: 1,
    })
  }

  monthChoosen = (month) => {
    this.setState({
      month,
      choosing: 2,
    })
  }

  dateChoosen = (date) => {
    if(this.props.ymOnlyOnce) {
      /*this.setState({
        choosing: 0,
      })  */  
    } else {
      this.setState({
        choosing: 0,
      })
    }
    this.props.onDayClick(date);
  }

  render() {
    return (
      <div>
        <ChooseYear onChange={this.yearChoosen} active={this.state.choosing === 0} />
        <ChooseMonth onChange={this.monthChoosen} active={this.state.choosing === 1} />
        <ChooseDay 
          month={moment({year: this.state.year, month: this.state.month}).toDate()} 
          onChange={this.dateChoosen} active={this.state.choosing === 2} />
      </div>
    )
  }
}


let abc = 0;

class BackgroundWrapper extends React.Component {
  render() {
    if(this.props.value) {
      if(abc++ < 10) {
      }
    }
    const {modifiers} = this.context;
    let classes = [];
    for(let className in modifiers) {
      let interval = modifiers[className];
      let {from, to} = interval;
      if(moment(from).isSameOrBefore(moment(this.props.value)) && 
        moment(this.props.value).isSameOrBefore(moment(to))) {
        classes.push(className);
      }
    }
    return React.cloneElement(React.Children.only(this.props.children), {
      className: "rbc-time-slot" + " " + classes.join(' '),
      onClick: () => this.context.onSlotClick(this.props.value),
      onMouseEnter: () => this.context.onSlotMouseEnter(this.props.value),
    });
  }
}
BackgroundWrapper.contextTypes = {
  modifiers: PropTypes.object,
  onSlotClick: PropTypes.func,
  onSlotMouseEnter: PropTypes.func,
}

export class WeekCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selecting: 0,
      startTime: undefined,
      endTime: undefined,
    }
  }


  getDefaultProps() {
    return {
      modifiers: {},
    }
  }

  getChildContext() {
    let wantedSelection = {...this.props.wantedSelection};
    if(this.state.selecting === 1) {
      wantedSelection.from = this.state.startTime;
      wantedSelection.to = this.state.endTime || this.state.startTime;
    }
    return {
      modifiers: {
        wantedSelection: wantedSelection,
        realSelection: this.props.realSelection,
      },
      onSlotClick: this.handleSlotClick,
      onSlotMouseEnter: this.handleSlotMouseEnter,
    }
  }

  handleSlotClick = (time) => {
    if(this.state.selecting === 0) {
      this.setState({selecting: 1, startTime: time});
    } else if(this.state.selecting === 1) {
      this.props.onChange && this.props.onChange({from: moment(this.state.startTime), to: moment(time)});
      this.setState({selecting: 0, startTime: undefined, endTime: undefined})
    }
  }

  handleSlotMouseEnter = (time) => {
    if(this.state.selecting === 1) {
      this.setState({endTime: time});
    }
  }

  handleView(date) {
  }

  render() {
    let defaultDate;
    if(this.props.defaultDate && !isNaN(this.props.defaultDate.getTime())) {
      defaultDate = this.props.defaultDate;
    }
    return <BigCalendar 
      components={{
        dayWrapper: BackgroundWrapper,
        //dateCellWrapper: BackgroundWrapper,
      }}    
      {...this.props} 
      defaultDate={defaultDate}
      onView={this.handleView}
    />
  } 
}

WeekCalendar.childContextTypes = {
  modifiers: PropTypes.object,
  onSlotClick: PropTypes.func,
  onSlotMouseEnter: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/visual/component/DayPicker.js